// routes/_app.submit.upload.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.submit.upload')

export const handle = {
  name: 'submit/upload',
  track: { scene: 'upload-artwork' },
}

export default dynamic(getClientModule, { ssr: false })
